import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LeaveInCanadaNoScreen = () => {
  const { t } = useTranslation();
  return (
    <div className="container-fluid if-no-leave-canada-fluid">
      <div className="container">
        <div className="row">
          <div className="col-12 back-arrow-div">
            <Link className="d-flex align-items-center" to={-1}>
              <img
                src="/assets/images/icons/back-arrow-icon.png"
                className="img-fluid"
                alt=""
              />
              {t("aboutYou.backBtn")}
            </Link>
          </div>
        </div>
        <div className="row mx-0 resourec-main-row">
          <div className="col-12">
            <img
              src="/assets/images/not-live-canada-bg-banner.png"
              className="img-fluid banner-img-"
              alt=""
            />
            <div className="row mx-0 resource-inner-main">
              <div className="col-12">
                <div className="row mx-0 gray-bg-box">
                  <div className="col-12">
                    <h6>{t("preArrival.1")}</h6>
                    <p>{t("preArrival.2")}</p>
                    <p>{t("preArrival.3")}</p>
                    <h6>{t("preArrival.4")}</h6>
                    <p className="mb-0">{t("preArrival.5")}</p>
                  </div>
                </div>
                <h2>{t("preArrival.6")}</h2>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.7.child1")}</h4>
                    <p>{t("preArrival.7.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open(
                          "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada.html"
                        )
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.8.child1")}</h4>
                    <p>{t("preArrival.8.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open(
                          "https://www.canada.ca/en/immigration-refugees-citizenship/services/new-immigrants/new-life-canada/pre-arrival-services/prepare-live.html"
                        )
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.14.child1")}</h4>
                    <p>{t("preArrival.14.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open("https://oca.si/Settlementorg")
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.9.child1")}</h4>
                    <p>{t("preArrival.9.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open(
                          "http://www.creditcanada.com/budgeting-newcomers"
                        )
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.10.child1")}</h4>
                    <p>{t("preArrival.10.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open(
                          "https://www.creditcanada.com/elearning-newcomers"
                        )
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.11.child1")}</h4>
                    <p>{t("preArrival.11.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open("https://achev.ca/services/newcomer/")
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.12.child1")}</h4>
                    <p>{t("preArrival.12.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open("https://bit.ly/CreditCanadaxPeaceGeeks")
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
                <div className="row mx-0 resource-details-card">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10">
                    <h4>{t("preArrival.13.child1")}</h4>
                    <p>{t("preArrival.13.child2")}</p>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                    <Button
                      className="btn auth-theme-btn"
                      onClick={() =>
                        window.open(
                          "https://www.savvynewcanadians.com/financial-checklist-for-newcomers-to-canada/"
                        )
                      }
                    >
                      {t("newTab")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveInCanadaNoScreen;
